define('models/zendesk/ArticleModel',['underscore','ObjectModel','UrlFactory','string'],
    function (_,ObjectModel,UrlFactory,S) {
    //
    // Model Zendesk Article
    //

    return ObjectModel.extend({

        name:'ZendeskArticleModel',
        idAttribute:'id',
        defaults:{
            id_form:false,
            id_motif:false,
        },

        getName:function(){
            return this.get('name');
        },
        getUrl: function () {
            return UrlFactory.getUrl('supportCenterResource', {type: 'article', id: this.id});
        },
        getBody:function(){
            return this.get('body');
        },
        getLabelNameSize:function(){
            var labelNames = this.get('label_names');
            return labelNames ? labelNames.length : 0;
        },
        getSection:function(){
            var model = this,
                section_id = model.get('section_id'),
                section = model.collection.supportCenter.getSection(section_id);
            return section;
        },
        hasForm:function(){
            return this.getFormId() != false;
        },
        hasButtonActions:function(){
            return this.hasForm() || this.hasOrderLink();
        },
        hasOrderLink:function(){
            return /^ORDER_/.test(this.getIdInternal() || '');
        },
        getIdInternal:function(){
            return this.get('id_internal');
        },
        getFormId:function(){
            return this.get('id_form');
        },
        getMotifId:function(){
            return this.get('id_motif');
        },
        getForm:function(){
            var model = this;
            return model.collection.supportCenter.getForm(model.getFormId());
        },
        getCategory:function(){
            return this.getSection().getCategory();
        },
        isDirect:function(){
            return this.getCategory().isDirect();
        },
        isFormDirect:function(){
            //
            var regExp = / ?[,;] ?/g,
                formsVisible = S(app.c('_ZENDESK_ARTICLE_FORM_DIRECT_LIST_')||'').trim().s.split(regExp),
                isFormDirect = _.contains(formsVisible,''+this.id);
            return isFormDirect;
        },
        isOrder:function(isComplete){
            var id_internal = this.getIdInternal(), isOrder = false;
            if(!!id_internal && isComplete && /^ORDER_COMPLETE/.test(id_internal)){
                isOrder = true;
            }else if(!!id_internal && !isComplete && /^ORDER_INPROGRESS/.test(id_internal)){
                isOrder = true;
            }
            return isOrder;
        },


    })
});
